export default {
  name: "take-photo",
  props: {
    title: {
      type: String
    },
    height: {
      type: Number,
      default: 250
    },
    previewHeight: {
      type: Number,
      default: 250
    }
  },
  components: {},
  data() {
    return {
      takePhotoModal: false,
      imageDataUrl: null,
      file: null,
      hasCameraAccess: false
    };
  },
  computed: {},
  mounted() {},
  methods: {
    async openPhotoModal() {
      this.takePhotoModal = true;
      await this.startTakingPhoto();
    },
    closePhotoModal() {
      let video = document.querySelector("#video");
      let canvas = document.querySelector("#canvas");
      video.style.display = "block";
      canvas.style.display = "none";
      this.takePhotoModal = false;
      this.imageDataUrl = null;
    },
    async startTakingPhoto() {
      try {
        this.hasCameraAccess = false;
        let video = await document.querySelector("#video");
        let canvas = await document.querySelector("#canvas");
        canvas.style.display = "none";
        let stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: "user" },
          audio: false
        });
        video.srcObject = stream;
      } catch (e) {
        console.log(e);
        this.hasCameraAccess = true;
        await this.tryStartTakingPhoto();
      }
    },
    async tryStartTakingPhoto() {
      let video = await document.querySelector("#video");
      let canvas = await document.querySelector("#canvas");
      canvas.style.display = "none";
      let stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "user" },
        audio: false
      });
      video.srcObject = stream;
      this.hasCameraAccess = false;
    },
    takePhoto() {
      let photoBox = document.querySelector(".photo-box");
      let canvas = document.querySelector("#canvas");
      let video = document.querySelector("#video");
      canvas
        .getContext("2d")
        .drawImage(
          video,
          0,
          0,
          photoBox.offsetWidth + 50,
          photoBox.offsetHeight
        );
      video.style.display = "none";
      canvas.style.display = "block";
      this.imageDataUrl = canvas.toDataURL("image/jpeg");
    },
    retake() {
      this.imageDataUrl = null;
      let canvas = document.querySelector("#canvas");
      let video = document.querySelector("#video");
      video.style.display = "block";
      canvas.style.display = "none";
    },
    continueUpload() {
      fetch(this.imageDataUrl)
        .then(res => res.blob())
        .then(blob => {
          const file = new File([blob], "image.jpg", { type: "image/jpeg" });
          this.$emit("pushPhotoUp", file);
        })
        .then(() => {
          this.closeVideoModule();
        });
    },
    closeVideoModule() {
      let video = document.querySelector("#video");
      const mediaStream = video.srcObject;
      const tracks = mediaStream.getTracks();
      tracks.forEach(track => track.stop());
    }
  }
};
